import { render, staticRenderFns } from "./PrembR.vue?vue&type=template&id=6eac2826&scoped=true"
import script from "./PrembR.vue?vue&type=script&lang=js"
export * from "./PrembR.vue?vue&type=script&lang=js"
import style0 from "./PrembR.vue?vue&type=style&index=0&id=6eac2826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac2826",
  null
  
)

export default component.exports